function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * A codec for encoding and decoding parameters in URLs.
 *
 * Used by `HttpParams`.
 *
 * @publicApi
 **/

/**
 * A class that uses `encodeURIComponent` and `decodeURIComponent` to
 * serialize and parse URL parameter keys and values. If you pass URL query parameters
 * without encoding, the query parameters can get misinterpreted at the receiving end.
 * Use the `HttpParameterCodec` class to encode and decode the query-string values.
 *
 * @publicApi
 */
export var HttpUrlEncodingCodec = /*#__PURE__*/function () {
  function HttpUrlEncodingCodec() {
    _classCallCheck(this, HttpUrlEncodingCodec);
  }
  _createClass(HttpUrlEncodingCodec, [{
    key: "encodeKey",
    value: function encodeKey(key) {
      return standardEncoding(key);
    }
  }, {
    key: "encodeValue",
    value: function encodeValue(value) {
      return standardEncoding(value);
    }
  }, {
    key: "decodeKey",
    value: function decodeKey(key) {
      return decodeURIComponent(key);
    }
  }, {
    key: "decodeValue",
    value: function decodeValue(value) {
      return decodeURIComponent(value);
    }
  }]);
  return HttpUrlEncodingCodec;
}();
function paramParser(rawParams, codec) {
  var map = new Map();
  if (rawParams.length > 0) {
    var params = rawParams.split('&');
    params.forEach(function (param) {
      var eqIdx = param.indexOf('=');
      var _ref = eqIdx == -1 ? [codec.decodeKey(param), ''] : [codec.decodeKey(param.slice(0, eqIdx)), codec.decodeValue(param.slice(eqIdx + 1))],
        _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];
      var list = map.get(key) || [];
      list.push(val);
      map.set(key, list);
    });
  }
  return map;
}
function standardEncoding(v) {
  return encodeURIComponent(v).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/gi, '$').replace(/%2C/gi, ',').replace(/%3B/gi, ';').replace(/%2B/gi, '+').replace(/%3D/gi, '=').replace(/%3F/gi, '?').replace(/%2F/gi, '/');
}

/** Options used to construct an `HttpParams` instance. */

/**
 * An HTTP request/response body that represents serialized parameters,
 * per the MIME type `application/x-www-form-urlencoded`.
 *
 * This class is immutable - all mutation operations return a new instance.
 *
 * @publicApi
 */
export var HttpParams = /*#__PURE__*/function () {
  function HttpParams() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, HttpParams);
    _defineProperty(this, "map", void 0);
    _defineProperty(this, "encoder", void 0);
    _defineProperty(this, "updates", null);
    _defineProperty(this, "cloneFrom", null);
    this.encoder = options.encoder || new HttpUrlEncodingCodec();
    if (!!options.fromString) {
      if (!!options.fromObject) {
        throw new Error("Cannot specify both fromString and fromObject.");
      }
      this.map = paramParser(options.fromString, this.encoder);
    } else if (!!options.fromObject) {
      this.map = new Map();
      Object.keys(options.fromObject).forEach(function (key) {
        var value = options.fromObject[key];
        if (value === undefined) {
          return;
        }
        _this.map.set(key, Array.isArray(value) ? value : [value]);
      });
    } else {
      this.map = null;
    }
  }

  /**
   * Check whether the body has one or more values for the given parameter name.
   */
  _createClass(HttpParams, [{
    key: "has",
    value: function has(param) {
      this.init();
      return this.map.has(param);
    }

    /**
     * Get the first value for the given parameter name, or `null` if it's not present.
     */
  }, {
    key: "get",
    value: function get(param) {
      this.init();
      var res = this.map.get(param);
      return !!res ? res[0] : null;
    }

    /**
     * Get all values for the given parameter name, or `null` if it's not present.
     */
  }, {
    key: "getAll",
    value: function getAll(param) {
      this.init();
      return this.map.get(param) || null;
    }

    /**
     * Get all the parameter names for this body.
     */
  }, {
    key: "keys",
    value: function keys() {
      this.init();
      return Array.from(this.map.keys());
    }

    /**
     * Construct a new body with an appended value for the given parameter name.
     */
  }, {
    key: "append",
    value: function append(param, value) {
      return this.clone({
        param: param,
        value: value,
        op: 'a'
      });
    }

    /**
     * Construct a new body with a new value for the given parameter name.
     */
  }, {
    key: "set",
    value: function set(param, value) {
      return this.clone({
        param: param,
        value: value,
        op: 's'
      });
    }

    /**
     * Construct a new body with either the given value for the given parameter
     * removed, if a value is given, or all values for the given parameter removed
     * if not.
     */
  }, {
    key: "delete",
    value: function _delete(param, value) {
      return this.clone({
        param: param,
        value: value,
        op: 'd'
      });
    }

    /**
     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
     * separated by `&`s.
     */
  }, {
    key: "toString",
    value: function toString() {
      var _this2 = this;
      this.init();
      return this.keys().map(function (key) {
        var eKey = _this2.encoder.encodeKey(key);
        return _this2.map.get(key).map(function (value) {
          return eKey + '=' + _this2.encoder.encodeValue(value);
        }).join('&');
      }).join('&');
    }
  }, {
    key: "clone",
    value: function clone(update) {
      var clone = new HttpParams({
        encoder: this.encoder
      });
      clone.cloneFrom = this.cloneFrom || this;
      clone.updates = (this.updates || []).concat([update]);
      return clone;
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      if (this.map === null) {
        this.map = new Map();
      }
      if (this.cloneFrom !== null) {
        this.cloneFrom.init();
        this.cloneFrom.keys().forEach(function (key) {
          return _this3.map.set(key, _this3.cloneFrom.map.get(key));
        });
        this.updates.forEach(function (update) {
          switch (update.op) {
            case 'a':
            case 's':
              var base = (update.op === 'a' ? _this3.map.get(update.param) : undefined) || [];
              base.push(update.value);
              _this3.map.set(update.param, base);
              break;
            case 'd':
              if (update.value !== undefined) {
                var _base = _this3.map.get(update.param) || [];
                var idx = _base.indexOf(update.value);
                if (idx !== -1) {
                  _base.splice(idx, 1);
                }
                if (_base.length > 0) {
                  _this3.map.set(update.param, _base);
                } else {
                  _this3.map.delete(update.param);
                }
              } else {
                _this3.map.delete(update.param);
                break;
              }
          }
        });
        this.cloneFrom = null;
      }
    }
  }]);
  return HttpParams;
}();